import { IRole } from '../appModels/IRole';

export interface INavItem {
  label?: string;
  url?: string;
  icon?: string;
  roles?: IRole[];
  businessType?: string; // Optional property
}

export const Nav: INavItem[] = [
  // { label: 'Dashboard', url: 'dashboard', icon: 'grid', roles: [IRole.Admin] },
  {
    label: 'Guest',
    url: 'guest',
    icon: 'people',
    roles: [IRole.Admin, IRole.Cashier],
  },
  {
    label: 'POS',
    url: 'pos',
    icon: 'storefront',
    roles: [IRole.Admin, IRole.Cashier],
  },
  {
    label: 'Table',
    url: 'table',
    icon: 'bowling-ball',
    roles: [IRole.Admin, IRole.Cashier],
  },
  {
    label: 'Orders',
    url: 'transactions',
    icon: 'albums',
    roles: [IRole.Admin, IRole.Cashier],
  },
  // { label: 'CDS', url: 'cds', icon: 'tv', roles: [IRole.Admin, IRole.Cashier] },
  {
    label: 'Menu',
    url: 'outlet',
    icon: 'grid',
    roles: [IRole.Admin, IRole.Cashier],
  },
  {
    label: 'Report',
    url: 'reports',
    icon: 'bar-chart',
    roles: [IRole.Admin, IRole.Cashier],
  },
  {
    label: 'Settings',
    url: 'settings',
    icon: 'settings',
    roles: [IRole.Admin, IRole.Cashier],
  },
];

/**
 * Items that are safe to display while an authenticated profile is loading
 * or temporarily unavailable. Future role-specific entries are excluded
 * automatically.
 */
export const CommonNavItems: INavItem[] = Nav.filter((item) =>
  [IRole.Admin, IRole.Cashier].every((role) => item.roles?.includes(role)),
);
